import { convertPxsToRems } from '@openbank/cf-ui-framework';

const PARAGRAPH_PROPS = {
  size: 'MEDIUM' as any,
};

const PARAGRAPH_PHONE_PROPS = {
  ...PARAGRAPH_PROPS,
  weight: 'BOLD' as any,
};

const INPUT_OTP_CONSTANTS = {
  VARIANT: 'DEFAULT',
};

const INPUT_OTP_INPUT_PROPS = {
  errorIcon: 'icon_symbols_alert',
  maxLength: 4,
  maskType: 'NUMBERS' as any,
};

const INPUT_OTP_INPUT_CLEAR_ICON_PROPS = {
  icon: 'icon_symbols_error',
};

const INPUT_OTP_BUTTON_PROPS = {
  size: 'EXTRA_SMALL',
  type: 'PRIMARY_GHOST',
};

const SNACKBAR_PROPS = {
  align: 'BOTTOM_CENTER_FIXED' as any,
  closeIcon: { icon: 'icon_symbols_close-thick' },
  closeTimeout: 5000,
  popover: {
    focusFirstDescendantAutomatically: false,
    trapFocusInsideModal: false,
  },
  variant: 'DEFAULT',
};

const HASHED_PHONE_SKELETON_PROPS = {
  height: convertPxsToRems({ pixels: 24 }),
  shapeVariant: 'SQUARE',
  variant: 'SQUARE_DEFAULT',
  width: convertPxsToRems({ pixels: 210 }),
};

const ERROR_VERIFY = 'ERROR_VERIFY';
const ERROR = 'ERROR';

const OTP_RETRY_TIMEOUT_KEY = 'otpLastRequest';
const OTP_RETRY_TIMEOUT_MILLIS = 15000;
const ONE_SECOND_MILIS = 1000;
const OTP_RETRY_TIMEOUT_SECONDS = OTP_RETRY_TIMEOUT_MILLIS / ONE_SECOND_MILIS;

const OTP_NEW_CODE_PROPS = {
  code: '',
  delay: OTP_RETRY_TIMEOUT_SECONDS,
  disabled: true,
  id: null,
  msg: null,
  open: false,
};

const OTP_DEFAULT_PROPS = {
  attempts: null,
  code: '',
  disabled: true,
  error: false,
  id: null,
  msg: null,
  open: false,
};

const VERYFY_DEFAULT_PROPS = {
  attempts: null,
  showAttemptsWarning: false,
  disabled: true,
  fetching: false,
  msg: null,
};

export {
  ERROR,
  ERROR_VERIFY,
  HASHED_PHONE_SKELETON_PROPS,
  INPUT_OTP_BUTTON_PROPS,
  INPUT_OTP_CONSTANTS,
  INPUT_OTP_INPUT_CLEAR_ICON_PROPS,
  INPUT_OTP_INPUT_PROPS,
  ONE_SECOND_MILIS,
  OTP_DEFAULT_PROPS,
  OTP_NEW_CODE_PROPS,
  OTP_RETRY_TIMEOUT_KEY,
  OTP_RETRY_TIMEOUT_MILLIS,
  OTP_RETRY_TIMEOUT_SECONDS,
  PARAGRAPH_PHONE_PROPS,
  PARAGRAPH_PROPS,
  SNACKBAR_PROPS,
  VERYFY_DEFAULT_PROPS,
};
